import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    calculations: {
      id: 'pages.calculationView.breadcrumbs.calculations',
      defaultMessage: 'Calculations',
      description: 'label of the breadcrumb calculations on the calculation view page',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.calculationView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the calculation view page',
    },
    items: {
      id: 'pages.calculationView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items tab on the calculation view page',
    },
    logs: {
      id: 'pages.calculationView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the calculation view page',
    },
    communication: {
      id: 'pages.calculationView.subNavigation.communication',
      defaultMessage: 'Communication',
      description: 'label of the communication tab on the calculation view page',
    },
  },
  secondaryActions: {
    createInvoice: {
      id: 'pages.calculationView.secondaryActions.createInvoice',
      defaultMessage: 'Create invoice',
      description: 'Label of the secondary action create invoice on the calculation view page',
    },
  },
  feedback: {
    invoiceNotCreated: {
      id: 'pages.calculationView.feedback.invoiceNotCreated',
      defaultMessage: 'Invoice could not be created',
      description: 'Error message of the create invoice action on the calculation view page',
    },
  },
};

export default defineMessages(translations);
